export default "__VITE_ASSET__10892aa8__"